import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { useRef, useState } from 'react'

import cn from './ModalMessageErrorField.module.scss'
import { useIsOverflowing } from './useIsOverflowing'

interface ModalMessageErrorFieldProps {
  label: string
  value: string
}

function ModalMessageErrorField({ label, value }: ModalMessageErrorFieldProps) {
  const [isExpanded, setIsExpanded] = useState(false)
  const boxRef = useRef<HTMLDivElement>(null)
  const isOverflowing = useIsOverflowing(boxRef)

  const handleToggle = () => {
    if (isExpanded && boxRef.current) boxRef.current.scrollTop = 0
    setIsExpanded(!isExpanded)
  }

  return (
    <div className={cn.field}>
      <div className={cn.header}>
        <span className={cn.label}>{label}</span>
        {(isOverflowing || isExpanded) && (
          <button
            type="button"
            className={cn.toggle}
            aria-expanded={isExpanded}
            onClick={handleToggle}
          >
            {isExpanded ? (
              <ShrinkOutlined aria-hidden />
            ) : (
              <ArrowsAltOutlined aria-hidden />
            )}
            {isExpanded ? 'Свернуть' : 'Развернуть'}
          </button>
        )}
      </div>
      <div
        ref={boxRef}
        className={classNames(cn.box, isExpanded && cn.boxExpanded)}
      >
        {value}
      </div>
    </div>
  )
}

export default ModalMessageErrorField
